export const JPEG = 'image/jpeg';
export const PNG = 'image/png';
export const GIF = 'image/gif';
export const SVG = 'image/svg';
export const SVG_XML = 'image/svg+xml';

const MIME_TYPES = [JPEG, PNG, GIF, SVG, SVG_XML];

export const FAVICON_MIME_TYPES = [JPEG, PNG, GIF];

export const AVATAR_MIME_TYPE = [JPEG, PNG, GIF];

export const SHARE_CARD_IMAGE_TYPES = [JPEG, PNG, GIF];

export default MIME_TYPES;
